// Lake Life Designs: Search button next to Filters on collection pages (phones and small tablets).
// Opens the same filter panel and puts the cursor in the collection search box.
// Loaded from sections/header.liquid. It waits for DOMContentLoaded so theme.js has added the Filters button first.
(function () {
  function init() {
    var sidebar = document.getElementById('CollectionSidebar');
    var input   = document.getElementById('CollectionSearchInput');
    var filters = document.querySelector('.collection-toolbar__left .mobile-filter-trigger');
    if (!sidebar || !input || !filters || document.querySelector('.mobile-search-trigger')) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'btn btn--outline mobile-search-trigger';
    btn.setAttribute('aria-label', 'Search this collection');
    btn.style.cssText = 'display:none;align-items:center;gap:6px;font-size:0.8rem;padding:0.45em 0.9em;margin-left:8px;';
    btn.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg> Search';
    btn.addEventListener('click', function () {
      sidebar.classList.add('open');
      try { input.focus({ preventScroll: true }); } catch (e) { input.focus(); }
    });
    filters.insertAdjacentElement('afterend', btn);
    function sync() { btn.style.display = window.innerWidth <= 860 ? 'inline-flex' : 'none'; }
    sync();
    window.addEventListener('resize', sync);
  }
  if (document.readyState === 'complete') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
